import { http, http2 } from '@/plugins/api';

const base = 'product';

export const getProducts = () => {
  const url = `/${base}/products?page[number]=1&page[size]=9999`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
};

export const getSubProducts = (id) => {
  const url = `/${base}/sub_products?filter[produk_id]=${id}&filter[status_id]=10`;
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http2.get(url, {
    headers,
  });
};


// export const getSubProductsComposer = (id, page) => {
//   const url = `/transaction-composer/sub-products?include=owner&filter[produk_id]=${id}&filter[status_id]=10&page[number]=${page}&page[size]=50`;
//   const headers = {
//     'Accept': 'application/vnd.api+json',
//     'Content-Type': 'application/vnd.api+json',
//   };
  
//   return http.get(url, {
//     headers,
//   });
// };

export const getSubProductsComposer = (id, page) => {
  // const url = `/transactioncomposer/sub-products?include=owner&filter[produk_id]=${id}&filter[status_id]=10&page[number]=${page}`;
  const url = `/product/sub_products?include=owner&filter[produk_id]=${id}&filter[status_id]=10&page[number]=${page}`;
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http2.get(url, {
    headers,
  });
};

export const getSubProductsNews = () => {
  const url = `/${base}/sub_products?sort=-id&page[size]=6&filter[status_id]=10`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
};

export const getSubProductsByName = (name) => {
  const url = `/transaction-composer/sub-products?filter[nama]=${name}&filter[status_id]=10&include=owner`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
};


export const getSubProductDetail = (id) => {
  const url = `/${base}/sub_products/${id}?include=owner`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http2.get(url, {
    headers,
  });
};

export const getTags = (id) => {
  const url = `/${base}/produk_tags?filter[produk_id]=${id}&include=tag`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };
  
  return http.get(url, {
    headers,
  });
};

export const getSubProductsByComposer = (id) => {
  const url = `/transaction-composer/sub-products/${id}?include=owner`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  }

  return http.get(url, {
    headers,
  });
}
